import React, { useEffect, useRef, useState } from "react";
import "./Service.css";
import Advanced from "../../../components/Advanced/Advanced";
import { toast } from "react-toastify";
import ServiceSeo from "./ServiceSeo";

const Service = () => {
    const [categoryId, setCategoryId] = useState("category005"); // Assuming categoryId is preset or dynamic
    const [banners, setBanners] = useState([{ id: 1, imgSrc: "", altText: "", file: null }]);
    const [faqs, setFaqs] = useState([{ id: 1, question: "Lorem ipsum dolor sit amet", answer: "" }]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editingFaq, setEditingFaq] = useState(null);
    const [activeTab, setActiveTab] = useState("web");

    const editorRef = useRef();
    const editorRef1 = useRef();
    const editorRef2 = useRef();
    const editorRef3 = useRef();
    const editorRef4 = useRef();

    // Fetch existing data for the category
    useEffect(() => {


        fetchData();
    }, []);
    const fetchData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCMSProductCategory/${categoryId}`);
            if (response.ok) {
                const result = await response.json();
                const { banners, faqs, editorContent,editorContent1,editorContent2,editorContent3,editorContent4 } = result.data;

                setBanners(banners.map((banner, index) => ({
                    id: index + 1,
                    imgSrc: banner.imgSrc, // URL path
                    altText: banner.altText,
                    file: null // Since it's an existing URL, no file is set
                })));
                setFaqs(faqs);
                setTimeout(() => {
                    editorRef?.current?.setContent(editorContent);
                    editorRef1?.current?.setContent(editorContent1 || "");
                    editorRef2?.current?.setContent(editorContent2 || "");
                    editorRef3?.current?.setContent(editorContent3 || "");
                    editorRef4?.current?.setContent(editorContent4 || "");
                }, 1000);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const toggleTab = (tab) => {
        setActiveTab(tab);
    };

   

    
    // API call function for creating or updating
    const handleSubmit = async () => {
        const formData = new FormData();

        // Append categoryId and editorContent
        formData.append('categoryId', categoryId);
        formData.append('editorContent', editorRef.current.getContent());
        formData.append('editorContent1', editorRef1.current.getContent());
        formData.append('editorContent2', editorRef2.current.getContent());
        formData.append('editorContent3', editorRef3.current.getContent());
        formData.append('editorContent4', editorRef4.current.getContent());

        // // Append banners
        // banners.forEach((banner, index) => {
        //     if (banner.file) {
        //         // If there's a file to upload
        //         formData.append(`banners[${index}][file]`, banner.file);
        //     } else {
        //         // If it's just an image URL
        //         formData.append(`banners[${index}][imgSrc]`, banner.imgSrc);
        //     }
        //     formData.append(`banners[${index}][altText]`, banner.altText);
        // });

        // Append FAQs as a JSON string
        // formData.append('faqs', JSON.stringify(faqs));

        // Send the API request
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotCMSProductCategory`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
                },
                body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                toast.success("Service and Policy updated Successfully");
                fetchData()
            } else {
                toast.error('An error occurred while making the API call');
            }
        } catch (error) {
            console.error('API Error:', error);
            toast.error('An error occurred while making the API call');
        }
    };

    return (
        <div>
            <section className="bg-color">
                <div className="container p-4">
                    <div className="p-4">
                        <div className="col-lg-12 top-selector d-flex">
                            <div
                                className={`col-6 seo-sec ${activeTab === "seo" ? "active" : ""}`}
                                onClick={() => toggleTab("seo")}
                            >
                                SEO Settings
                            </div>
                            <div
                                className={`col-6 web-sec ${activeTab === "web" ? "active" : ""}`}
                                onClick={() => toggleTab("web")}
                            >
                                Web Settings
                            </div>
                        </div>
                    </div>

                    <div className="row p-4">
                        <div className="col-lg-12 web-settings-content">
                            {activeTab === "web" && (
                                <>
                                    
                                    <div className="bannerWeb">

                                        <h5 className="top-banner">Distributor Policy</h5>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="p-2 mt-4">
                                                    <Advanced editorRef={editorRef} />
                                                </div>
                                            </div>
                                        </div>
                                        <h5 className="top-banner">Shipping Policy</h5>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="p-2 mt-4">
                                                    <Advanced editorRef={editorRef1} />
                                                </div>
                                            </div>
                                        </div>
                                        <h5 className="top-banner">Warranty Policy</h5>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="p-2 mt-4">
                                                    <Advanced editorRef={editorRef2} />
                                                </div>
                                            </div>
                                        </div>
                                        <h5 className="top-banner">Payment Security</h5>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="p-2 mt-4">
                                                    <Advanced editorRef={editorRef3} />
                                                </div>
                                            </div>
                                        </div>
                                        <h5 className="top-banner">CUSTOMER GRIEVANCE</h5>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <div className="p-2 mt-4">
                                                    <Advanced editorRef={editorRef4} />
                                                </div>
                                            </div>
                                        </div>



                                        <div className="bottom-btn justify-content-end align-content-end p-3">
                                            <button
                                                type="submit"
                                                className="submit1"
                                                onClick={() => {
                                                    setBanners([{ id: 1, imgSrc: "", altText: "", file: null }]);
                                                    setFaqs([{ id: 1, question: "Lorem ipsum dolor sit amet", answer: "" }]);
                                                    editorRef?.current?.setContent("");
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="submit2 m-1" style={{ color: "FFFFFF" }} onClick={() => {
                                                handleSubmit()
                                            }}>Apply</button>
                                        </div>
                                    </div>

                                </>
                            )}
                            {activeTab === "seo" && <ServiceSeo />}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Service;
